import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import {
  SortableElement,
} from 'react-sortable-hoc';

// Components
import DragHandle from '../../../../common/ui/DragHandle';
import Tag from '../../../common/Tag/Tag';

// To be done next WEDDINGS-1840-Priority-6
const RsvpListItem = SortableElement(({
  rsvp,
  onEdit,
}) => {
  const noPropagate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  const numGuestsInvited = rsvp.num_guests_attending + rsvp.num_guests_declined + rsvp.num_guests_not_responded;
  let trimmedRsvpName;
  if (rsvp.name) {
    trimmedRsvpName = rsvp.name.length > 30 ? `${rsvp.name.slice(0, 30)}...` : rsvp.name;
  }
  return (
    <li className="sortable-item editable-entity" onClick={() => onEdit(rsvp)}>
      <div className="col-sm-1">
        <DragHandle tooltip="Drag to reorder" />
      </div>
      <div className="col-sm-10 event-info">
        <span className="">
          <span className="event-title-v2">{trimmedRsvpName}</span>
          <span className="event-visibility">
            {rsvp.collect_rsvps ? (
              <Tag className="tag-primary">Online RSVP Enabled</Tag>
            ) : (
              <Tag className="tag-secondary">Online RSVP Disabled</Tag>
            )}
          </span>
        </span>
        <p className="description">
          <Link to="/wedding/manage/guests/build" className="text-primary" onClick={noPropagate}>
            {numGuestsInvited} {numGuestsInvited === 1 ? 'guest' : 'guests'} invited
          </Link>
        </p>
      </div>
      <div className="col-sm-1 entity-actions" onClick={noPropagate}>
        <button onClick={() => onEdit(rsvp)} title="Edit event" className="btn btn-icon with-tooltip no-tooltip-on-mobile" data-tooltip="Edit"><i className="glyphicon glyphicon-pencil" /></button>
      </div>
    </li>
  );
});

RsvpListItem.propTypes = {
  rsvp: PropTypes.shape({}).isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default RsvpListItem;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Rsvp/RsvpListItem.jsx